module.exports = __webpack_public_path__ + "img/package-size-medium.c5a8d31d.png";